<template>
  <BaseTemplate :currentUser="currentUser">
    <div class="buy-point-history">
      <Title :jpn="t('履歴')" />
      <HistoryHeader />
      <HistoryTable
        v-if="dispHistoryList && dispHistoryList.length > 0"
        class="history-table"
        :historyList="dispHistoryList"
        :headerNameList="headerNameList"
        :dispKeyList="dispKeyList"
        :headerWidthList="headerWidthList"
      />
      <div
        v-if="!(dispHistoryList && dispHistoryList.length > 0)"
        class="no-history"
      >
        <span>No purchase history.</span>
      </div>
      <BoxPager
        v-if="dispHistoryList &&
          dispHistoryList.length > 0 &&
          pointHistoryList &&
          pointHistoryList.page.pages.length > 0
        "
        class="box-pager"
        :totalPageCount="pointHistoryList.page.all_page"
        :currentPageCount="pointHistoryList.page.page"
        :dispBoxCount="pointHistoryList.page.pages.length"
        :pages="pointHistoryList.page.pages"
        @handlePagerClick="changeCurrentPageCount"
        @handleSquareBtnClick="changeCurrentPageCount"
      />
    </div>
  </BaseTemplate>
</template>

<script>
import { mapGetters } from 'vuex';
import {
  separateCharacterNumber,
} from '@/common/util/format';

import BaseTemplate from '@/components/templates/BaseTemplate.vue';
import HistoryTable from '@/components/organisms/HistoryTable02.vue';
import BoxPager from '@/components/organisms/BoxPager.vue';
import Title from '@/components/molecules/Title02.vue';
import HistoryHeader from '@/components/molecules/HistoryHeader.vue';
import t from '@/plugins/i18n';

export default {
  name: 'BuyPointHistory',
  mixins: [t],

  components: {
    BaseTemplate,
    HistoryTable,
    BoxPager,
    Title,
    HistoryHeader,
  },

  data: () => ({
    headerNameList: [],
    dispKeyList: [
      'created',
      'bonusPoint',
      'money',
      'memo',
    ],
    headerWidthList: ['20%', '40%', '20%', '20%'],
  }),

  computed: {
    ...mapGetters({
      currentUser: 'user/currentUser',
      pointHistoryList: 'pointHistory/pointHistoryList',
    }),
    dispHistoryList() {
      if (this.pointHistoryList) {
        if (this.pointHistoryList.list.length > 0) {
          const dispHistoryList = this.pointHistoryList.list.reduce((acc, cur) => {
            const {
              id, bonusPoint, money, created, memo,
            } = cur;
            const historyId = cur.history_id;
            // const buyDate = created.split(' ')[0].slice(2);
            let moneyLabel = money;
            if (moneyLabel === '0') {
              moneyLabel = '-';
            } else {
              moneyLabel = `¥${separateCharacterNumber(money)}`;
            }
            acc.push({
              id,
              // buyDate,
              historyId,
              isCenterLink: bonusPoint <= 0 && historyId > 0,
              memo: this.t(memo),
              bonusPoint: `${separateCharacterNumber(bonusPoint)}`,
              money: moneyLabel,
              created,
            });
            return acc;
          }, []);
          return dispHistoryList;
        }
      }
      return [];
    },
  },

  created() {
    const pageNumber = 1;
    this.$store.dispatch('pointHistory/setPointHistoryList', { pageNumber });
    this.headerNameList = [
      this.t('日時'),
      this.t('コイン数'),
      this.t('お支払額'),
      this.t('備考'),
    ];
  },

  methods: {
    changeCurrentPageCount(pageNumber) {
      this.$store.dispatch('pointHistory/setPointHistoryList', { pageNumber });
    },
    center_click(row) {
      if (!row.isCenterLink) {
        return;
      }
      const packHistoryId = row.historyId;
      (async () => {
        // const query = {
        //   packHistoryId,
        // };
        await this.$store.dispatch('packHistory/setCurrentPackHistory', { packHistoryId });
        const currentPackHistory = this.$store.getters['packHistory/currentPackHistory'];
        const isDivision = currentPackHistory.status === '1';
        if (isDivision) {
          // this.$router.push({ path: '/buy-product-history-detail', query });
          this.$router.push('/');
        } else {
          this.$router.push('/get-card-list');
        }
      })();
    },
    goToPointBuy() {
      this.$router.push('./buy-point');
    },
  },
};
</script>

<style lang="scss" scoped>
$pagerWidth: 100%;

.buy-point-history{
  position: relative;
  padding: 30px 20px 90px;
  margin: 0px auto;
  border-top-left-radius: 0;
  border-top-right-radius: 0;
  @media screen and (min-width:767px){
    max-width: 580px;
  }
  @media screen and (min-width:1023px){
    max-width: 1000px;
  }
  .point_buy_area {
    display: flex;
    justify-content: center;
    align-items: center;
    margin-bottom: 20px;
  }
  .buy-point-history-title{
    display: flex;
    justify-content: center;
    .text{
      height: 44px;
      font-family: $notoSerif;
      font-size: 30px;
      font-weight: 700;
      color: $white;
      text-shadow: $titleShadow;
    }
  }
  .history-table{
    width: 100%;
  }
  .box-pager{
    width: $pagerWidth;
    height: 30px;
    margin: 0px auto;
  }
  .no-history{
    margin-top: 20px;
    font-family: $notoSans;
    font-size: 14px;
    line-height: 2.25;
    color: $white;
    text-align: center;
  }
}
@media screen and  (max-width: $tabletWidth) {
  .buy-point-history {
    padding: 30px 0 30px;
    .history-table {
      margin-top: 10px;
      margin-bottom: 30px;
    }
  }
}
</style>
